import { SignOutParams } from 'next-auth/react';
import { getRawLocalStorageItem } from 'src/services/storage/local';
import { performFederatedLogout } from 'src/components/ZillowNavbar/utils/performFederatedLogout';
import * as ApplicationConfigurationService from 'src/services/config/ApplicationConfigurationService.client';
import { zillowSignOut } from './zillowSignOut/zillowSignOut';

declare global {
    // eslint-disable-next-line no-var
    var signOutAlerted: boolean;
}

/**
 * This function handles session termination in multiple scenarios.
 *
 * Session termination can occur in the following ways:
 * - Receiving a 403 or 401 response from the GraphQL service.
 * - Failing to refresh the token from the accounts service.
 * - User action via the nav bar.
 *
 * This function consolidates the logic for all these scenarios to avoid
 * code duplication and conflicting paths.
 *
 * When `isDebugMode` is set in local storage in lower environments, it will not signout the user
 *
 * @param justification - Why the session is being terminated. used for debug purposes in lower environments
 */
export const QUICK_APP_AUTH_API_ENDPOINT = '/homeloans/quickapp/api/auth';
export const handleSessionTermination = async (
    justification: string,
    errorMessage?: string,
    config: SignOutParams = {}
) => {
    if (!globalThis.signOutAlerted && errorMessage) {
        globalThis.signOutAlerted = true;
        globalThis.alert(errorMessage);
    }
    const configService = ApplicationConfigurationService.ConfigProvider.getInstance();
    if (configService.runtimeConfig.isLowerEnvironment) {
        // eslint-disable-next-line no-console
        console.info('Application Sign Out Reason - ', justification);
        if (getRawLocalStorageItem('isDebugMode')) {
            return;
        }
    }
    try {
        await performFederatedLogout(QUICK_APP_AUTH_API_ENDPOINT);
    } catch (err) {
        // Suppress errors
    }
    zillowSignOut(config);
    return;
};
